// import external dependencies
import 'flexslider';
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// @codingStandardsIgnoreStart
$(document).ready(function () {

  $('.dropdown-toggle').click(function() { if ($(window).width() > 768) if ($(this).next('.dropdown-menu').is(':visible')) window.location = $(this).attr('href'); });

  $(window).load(function() {
    $('.flexslider').flexslider({
      animation: 'slide',
      controlNav: false,
      directionNav: false,
    });
  });

  // Set a variable for our button element.
  const scrollToTopButton = document.getElementById('js-top');

// Let's set up a function that shows our scroll-to-top button if we scroll beyond the height of the initial window.
  const scrollFunc = () => {
    // Get the current scroll value
    let y = window.scrollY;

    // If the scroll value is greater than the window height, let's add a class to the scroll-to-top button to show it!
    if (y > 0) {
      scrollToTopButton.className = 'top-link show';
    } else {
      scrollToTopButton.className = 'top-link hide';
    }
  };

  window.addEventListener('scroll', scrollFunc);

  const scrollToTop = () => {
    // Let's set a variable for the number of pixels we are from the top of the document.
    const c = document.documentElement.scrollTop || document.body.scrollTop;

    // If that number is greater than 0, we'll scroll back to 0, or the top of the document.
    // We'll also animate that scroll with requestAnimationFrame:
    // https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
    if (c > 0) {
      window.requestAnimationFrame(scrollToTop);
      // ScrollTo takes an x and a y coordinate.
      // Increase the '10' value to get a smoother/slower scroll!
      window.scrollTo(0, c - c / 10);
    }
  };

// When the button is clicked, run our ScrolltoTop function above!
  scrollToTopButton.onclick = function(e) {
    e.preventDefault();
    scrollToTop();
  }

  $(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
  });
});

// @codingStandardsIgnoreEnd



// WEBPACK FOOTER //
// ./scripts/main.js